import React from 'react';
import { useEffect, useState } from "react";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Message from "../tools/Message";
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import ImmobilisationService from "../../services/ImmobilisationService";
import InventoryService from "../../services/InventoryService";
import { useNavigate } from 'react-router-dom';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Spacer from '../../components/Spacer';

import {
    FormControl,
    Grid,
    TextField,
    Select,
    InputLabel,
    MenuItem
} from "@material-ui/core";
import AutocompleteCombobox from '../../components/AutocompleteCombobox';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

// États possibles, du meilleur au pire (ordre décroissant de qualité)
const ETATS = ["TRES BON ETAT", "BON ETAT", "MOYEN ETAT", "MAUVAIS ETAT"];

export default function InventoryInventaire(props) {
    const navigate = useNavigate();    
    const openDialog = props.open;
    const closeDialog = props.closeDialog;
    const dataImmo = props.dataImmo;
    const rows = props.rows;

    const [message, setMessage] = useState({
        open: false,
        color: 'green',
        messageInfo: '',
    });
    const { open, color, messageInfo } = message;

    const [form, setForm] = useState({
        user_id: "",
        dir: "",
    });

    // État local pour stocker les modifications d'états des immobilisations
    const [editedStates, setEditedStates] = useState({});

    // Initialiser les états édités à partir des données reçues
    useEffect(() => {
        if (props.dataImmo) {
            const initialStates = {};
            props.dataImmo.forEach((immo) => {
                initialStates[immo.code_immo_code] = immo.state;
            });
            setEditedStates(initialStates);
        }
    }, [props.dataImmo]);

    function handleCloseMessage() {
        setMessage({ ...message, open: false });
    }

    function handleClickReinit() {
        window.location.reload();
    }

    function handleChangeDir(directionId) {
        setForm({ ...form, dir: directionId });
    }

    function handleChangeUser(personId) {
        console.log("name : ", personId, "value : ", personId);
        setForm({ ...form, user_id: personId });
    }

    /**
     * Récupère les états possibles pour une immobilisation donnée.
     * Règle :
     * - On ne peut JAMAIS remonter en qualité (pas d'amélioration).
     * - On peut descendre à n'importe quel état inférieur (pas besoin de descendre cran par cran).
     * - Si l'état est déjà le plus bas (MAUVAIS ETAT), on ne peut plus changer.
     *
     * Exemple : si l'état est BON ETAT, on peut choisir BON ETAT, MOYEN ETAT ou MAUVAIS ETAT.
     */
    function getAvailableStates(currentState) {
        const currentIndex = ETATS.indexOf(currentState);
        if (currentIndex === -1) return ETATS; // Si l'état n'est pas reconnu, on autorise tout

        // On autorise l'état actuel et tous les états inférieurs (index >= currentIndex)
        return ETATS.slice(currentIndex);
    }

    function handleStateChange(codeImmo, newState) {
        setEditedStates((prev) => ({
            ...prev,
            [codeImmo]: newState,
        }));
    }

    function handleValidateImmoNewAffectation() {
        // On enrichit les données avec les nouveaux états
        const allImmoSelected = props.dataImmo.map((immo) => ({
            ...immo,
            state: editedStates[immo.code_immo_code] || immo.state,
        }));
        

        InventoryService.validateInventory(allImmoSelected, form.user_id).then((result) => {
            if (result.status == true) {
                setMessage({
                    ...message,
                    open: true,
                    color: "green",
                    messageInfo: result.message,
                });
                
                const intervalId = setInterval(() => {
                    window.location.reload();
                }, 2500);                
            }
            else{
                setMessage({
                    ...message,
                    open: true,
                    color: "red",
                    messageInfo: result.message,
                });
            }
        });
    }
    
    return (
        <div>
            <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
            <Dialog open={openDialog} onClose={closeDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth="lg">
                <DialogTitle id="form-dialog-title" color="primary">{"Inventaire matériel"}</DialogTitle>
                <DialogContent>
               
                <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">Code</TableCell>
                                    <TableCell align="left">Matériel</TableCell>
                                    <TableCell align="left">Date d'acquisition</TableCell>
                                    <TableCell align="left">Etat</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {props.dataImmo.map((row) => {
                                const currentState = editedStates[row.code_immo_code] || row.state;
                                const availableStates = getAvailableStates(row.state);
                                return (
                                    <TableRow key={row.code_immo_code}>
                                        <TableCell align="left">{row.code_immo_code}</TableCell>
                                        <TableCell align="left">{row.name}</TableCell>
                                        <TableCell align="left">{row.date_acquis}</TableCell>
                                        <TableCell align="left">
                                            <Select
                                                value={currentState}
                                                onChange={(e) => handleStateChange(row.code_immo_code, e.target.value)}
                                                variant="outlined"
                                                fullWidth
                                                disabled={availableStates.length <= 1}
                                            >
                                                {availableStates.map((state) => (
                                                    <MenuItem key={state} value={state}>
                                                        {state}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>

                <DialogActions>                    
                    <Button variant="contained" color="primary" onClick={handleValidateImmoNewAffectation}
                    style={{ backgroundColor:"green", color:"#FFFFFF" }}>Valider</Button>
                    <Button variant="contained" onClick={handleClickReinit} >Réinitialiser la liste</Button>
                    <Button variant="contained" color="secondary" onClick={closeDialog} >Annuler</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}